var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-5"},[(_vm.show)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.loadMore}},[(_vm.isLoading)?_c('i',{staticClass:"fas fa-sync fa-spin mr-2"}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.translate('show_more'))+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }